export const TSL_POSITIONS: Array<[string, string]> = [
  ["Właściciel firmy transportowej", "wlasciciel-firmy"],
  ["Dyrektor / CFO / Główna księgowa", "dyrektor"],
  ["Kierownik floty / transportu", "kierownik-floty"],
  ["Kierownik spedycji", "kierownik-spedycji"],
  ["Kierownik magazynu / logistyki", "kierownik-magazynu"],
  ["Dyspozytor", "dyspozytor"],
  ["Spedytor", "spedytor"],
  ["Specjalista ds. rozliczeń", "specjalista-rozliczen"],
  ["HR / Rekruter kierowców", "hr-rekruter"],
  ["Compliance / Prawnik", "compliance"],
  ["Inne", "inne"],
]

export const TSL_TAGS: Array<[string, string]> = [
  ["🛣️ Przepisy i regulacje", "regulacje"],
  ["🚓 Kontrole i kary", "kontrole"],
  ["💰 Stawki, ceny, indeksy", "stawki"],
  ["🛣️ Drogi i operacje", "drogi"],
  ["🇪🇺 Rynek europejski", "rynek-europejski"],
  ["🌍 Rynek globalny", "rynek-globalny"],
  ["🚛 Pojazdy i technologia", "pojazdy"],
  ["🌱 Środowisko i emisje", "srodowisko"],
  ["👷 Kierowcy i HR", "kierowcy-hr"],
  ["📦 Magazyn i intermodal", "magazyn"],
  ["📊 Raporty i analizy", "raporty"],
  ["💼 Podatki i rozliczenia", "podatki"],
]

export const TSL_STATUSES: Array<[string, string]> = [
  ["Nowy (oczekuje na AI)", "new"],
  ["Gotowy", "processed"],
  ["Duplikat", "duplicate"],
  ["Błąd", "error"],
  ["Usunięty", "deleted"],
]

export const TSL_LANGUAGES: Array<[string, string]> = [
  ["🇵🇱 Polski (pl)", "pl"],
  ["🇩🇪 Niemiecki (de)", "de"],
  ["🇬🇧 Angielski (en)", "en"],
]

export const localeToFlag = (locale?: string | null): string => {
  switch (locale) {
    case "pl-PL":
    case "pl":
      return "🇵🇱"
    case "de-DE":
    case "de":
      return "🇩🇪"
    case "en-GB":
      return "🇬🇧"
    case "en-US":
      return "🇺🇸"
    case "fr-FR":
    case "fr":
      return "🇫🇷"
    default:
      return "🌐"
  }
}

export const positionLabel = (slug?: string | null): string => {
  if (!slug) return "—"
  return TSL_POSITIONS.find(([, v]) => v === slug)?.[0] ?? slug
}

export const tagLabel = (slug: string): string => {
  return TSL_TAGS.find(([, v]) => v === slug)?.[0] ?? slug
}

export const statusLabel = (status: string): string => {
  return TSL_STATUSES.find(([, v]) => v === status)?.[0] ?? status
}

export const priorityLabel = (priority: number | null): string => {
  if (priority === null || priority === undefined) return "—"
  if (priority >= 9) return "TOP"
  if (priority >= 6) return "Wysoka"
  if (priority >= 3) return "Normalna"
  return "Niska"
}

export const priorityColor = (priority: number | null): { bg: string; color: string } => {
  if (priority === null || priority === undefined) return { bg: "background", color: "third" }
  if (priority >= 9) return { bg: "redBackground", color: "red" }
  if (priority >= 6) return { bg: "orangeBackground", color: "orange" }
  if (priority >= 3) return { bg: "primaryBackground", color: "primary" }
  return { bg: "background", color: "third" }
}

export const statusColor = (status: string): { bg: string; color: string } => {
  switch (status) {
    case "processed":
      return { bg: "greenBackground", color: "green" }
    case "duplicate":
      return { bg: "orangeBackground", color: "orange" }
    case "error":
      return { bg: "redBackground", color: "red" }
    case "deleted":
      return { bg: "background", color: "third" }
    case "new":
    default:
      return { bg: "background", color: "second" }
  }
}
